import axios from 'axios';
import {
  Mail, MailCheck, Repeat, FileSignature, Phone, Video, MessageCircle, FileText, Eye, CheckCircle2,
} from 'lucide-react';

export const STAGES = [
  { id: 'new', label: 'Nuovo', color: 'bg-slate-500', text: 'text-slate-200', ring: 'border-slate-500/50' },
  { id: 'contacted', label: 'Contattato', color: 'bg-blue-500', text: 'text-blue-200', ring: 'border-blue-500/50' },
  { id: 'call_scheduled', label: 'Call fissata', color: 'bg-cyan-500', text: 'text-cyan-200', ring: 'border-cyan-500/50' },
  { id: 'offer_sent', label: 'Offerta inviata', color: 'bg-violet-500', text: 'text-violet-200', ring: 'border-violet-500/50' },
  { id: 'negotiation', label: 'Trattativa', color: 'bg-amber-500', text: 'text-amber-200', ring: 'border-amber-500/50' },
  { id: 'won', label: 'Vinto', color: 'bg-emerald-500', text: 'text-emerald-200', ring: 'border-emerald-500/50' },
  { id: 'lost', label: 'Perso', color: 'bg-rose-500', text: 'text-rose-200', ring: 'border-rose-500/50' },
];
export const stageOf = (id) => STAGES.find((s) => s.id === id) || STAGES[0];

export const PROSPECT_TYPES = [
  { id: 'privato', label: 'Privato' },
  { id: 'gruppo', label: 'Gruppo' },
  { id: 'asincrono', label: 'Asincrono' },
  { id: 'corporate', label: 'Corporate' },
];

export const EMAIL_TEMPLATES = [
  { key: 'welcome', label: 'Benvenuto onboarding' },
  { key: 'followup', label: 'Follow-up dopo 48h' },
  { key: 'proposal', label: 'Richiesta proposta su misura' },
];

export const ACTION_BADGES = [
  { key: 'email_welcome', label: 'Email benvenuto', icon: Mail },
  { key: 'email_followup', label: 'Follow-up 48h', icon: Repeat },
  { key: 'email_proposal', label: 'Richiesta proposta', icon: FileSignature },
  { key: 'email_custom', label: 'Email personalizzata', icon: MailCheck },
  { key: 'call', label: 'Telefonata', icon: Phone },
  { key: 'meeting', label: 'Call video / incontro', icon: Video },
  { key: 'whatsapp', label: 'WhatsApp', icon: MessageCircle },
  { key: 'offer_sent', label: 'Offerta inviata', icon: FileText },
  { key: 'offer_viewed', label: 'Offerta aperta dal cliente', icon: Eye },
  { key: 'offer_accepted', label: 'Offerta accettata', icon: CheckCircle2 },
];

// Known badges + any custom-template email (email_<key>) with its stored label.
export const actionItems = (done = {}) => {
  const known = ACTION_BADGES.filter((b) => done[b.key]);
  const knownKeys = new Set(ACTION_BADGES.map((b) => b.key));
  const custom = Object.keys(done)
    .filter((k) => k.startsWith('email_') && !knownKeys.has(k))
    .map((k) => ({ key: k, label: done[k].label || 'Email', icon: MailCheck }));
  return [...known.slice(0, 4), ...custom, ...known.slice(4)];
};

export const fmtDate = (iso, withTime = true) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('it-IT', withTime
    ? { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }
    : { day: '2-digit', month: 'short', year: 'numeric' });
};

export const money = (n) => `${Number(n || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const initials = (name = '') => name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join('') || '?';

export const makeApi = (backendUrl, token) => {
  const headers = { Authorization: `Bearer ${token}` };
  return {
    get: (p, params) => axios.get(`${backendUrl}/api${p}`, { headers, params }).then((r) => r.data),
    post: (p, d) => axios.post(`${backendUrl}/api${p}`, d || {}, { headers }).then((r) => r.data),
    patch: (p, d) => axios.patch(`${backendUrl}/api${p}`, d, { headers }).then((r) => r.data),
    put: (p, d) => axios.put(`${backendUrl}/api${p}`, d, { headers }).then((r) => r.data),
    del: (p) => axios.delete(`${backendUrl}/api${p}`, { headers }).then((r) => r.data),
  };
};

export const errMsg = (e, fallback = 'Operazione non riuscita') => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(' ');
  return fallback;
};
